import { Message, IMessage } from "./Message";

export interface IDocumentMessage extends IMessage {
    Document:IDocument;
}

export interface IDocument {

    Blob:string;
    MimeType:string;
    Preview:string;
   
}

export const DocumentMessage = (props:IDocumentMessage) => {

    const icon = (type)=> {
        switch(type){
                case "application/pdf":
                    return "doc-icon bi bi-filetype-pdf";
                case "application/doc":
                    return "doc-icon bi bi-filetype-doc";
                case "application/docx":
                case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    return "doc-icon bi bi-filetype-docx";
                case "application/xls":
                    return "doc-icon bi bi-filetype-xls";
                case "application/xlsx":
                case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    return "doc-icon bi bi-filetype-xlsx";
                case "application/ppt":
                    return "doc-icon bi bi-filetype-ppt";
                case "application/pptx":
                    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                    return "doc-icon bi bi-filetype-pptx";
                default:
                    return "bi bi-file";
                    }
    }


    return <Message {...props}>
        <div className="row  align-items-center justify-content-center">
            <div className="col text-center">
             <a className="btn" href={props.Document.Blob} target="_blank">
                    <i className={icon(props.Document.MimeType)} ></i>
                     </a>
             </div>
        </div>
        <div className="row justify-content-end">
           
            <div className="col col-auto">
                <a className="btn btn-outline-secondary" href={props.Document.Blob} target="_blank" download>
                    <i className="bi bi-download"></i>  
                </a>
            </div>
        </div>
         
    </Message>

}


